module.exports = __webpack_public_path__ + "img/L_316_326.0410b6bf.png";